import blankPage from '@/components/blankPage/index.vue';
export default [
  {
    name: 'EntryJourney',
    path: '/train/entry-journey',
    component: () => import('@/views/train/entry-journey/EntryJourney'),
    meta: {
      title: '入职之旅'
    }
  },
  {
    name: 'EntryJourneyConfig',
    path: '/train/entry-journey-config',
    component: () => import('@/views/train/entry-journey-config/index.vue'),
    meta: {
      title: '入职之旅配置'
    }
  },
  {
    name: 'OnlineCourses',
    path: '/train/OnlineCourses',
    component: () => import('@/views/train/online_courses/index.vue'),
    meta: {
      title: '在线课程',
      replaceSameTab: true,
    }
  },
  {
    name: 'OnlineCoursesDetail',
    path: '/train/OnlineCoursesDetail/:courseId',
    component: () => import('@/views/train/online_courses/detail/index'),
    meta: {
      title: '课程详情',
      parentAuth: '/train/OnlineCourses'
    }
  },
  {
    name: 'bannerManageList',
    path: '/bannerManage/list',
    component: () => import('@/views/train/banner_manage/list.vue'),
    meta: {
      title: 'banner管理'
    }
  },
  {
    name: 'lecturerManagement',
    path: '/train/lecturerManagement',
    component: blankPage,
    redirect: {
      name: 'lecturerManagementList'
    },
    children: [
      {
        name: 'lecturerManagementList',
        path: 'list',
        component: () => import('@/views/train/lecturerManagement/list.vue'),
        meta: {
          title: '讲师管理',
          parentAuth: '/train/lecturerManagement'
        }
      }
    ]
  },
  {
    name: 'LearningTask',
    path: '/train/LearningTask',
    component: () => import('@/views/train/learning-task/index.vue'),
    meta: {
      title: '学习任务'
    }
  },
  {
    name: 'PointManagement',
    path: '/train/PointManagement',
    component: () => import('@/views/train/point-management/index.vue'),
    meta: {
      title: '积分管理'
    }
  },
  {
    name: 'trainNewsManagement',
    path: '/train/newsManagement',
    component: () => import('@/views/newsManagement/linsyDynamics/index.vue'),
    meta: {
      title: '培训新闻管理'
    }
  },
  {
    name: 'addTrainNewsManagementDetails',
    path: '/train/newsManagement/add',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '新增培训新闻',
      parentAuth: '/train/newsManagement'
    },
    props: () => ({
      newsType: '2',
      type: 'add'
    })
  },
  {
    name: 'editTrainNewsManagementDetails',
    path: '/train/newsManagement/edit',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '编辑培训新闻',
      parentAuth: '/train/newsManagement'
    },
    props: () => ({
      newsType: '2',
      type: 'edit'
    })
  },
  {
    name: 'viewTrainNewsManagementDetails',
    path: '/train/newsManagement/view',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '查看培训新闻',
      parentAuth: '/train/newsManagement'
    },
    props: () => ({
      newsType: '2',
      type: 'view'
    })
  },
  {
    name: 'examinationManagementList',
    path: '/train/examinationManagement/list',
    component: () => import('@/views/train/examinationManagement/list.vue'),
    meta: {
      title: '考试中心',
    },
  },
  {
    name: 'examStatistic',
    path: '/train/examStatistic/:id',
    component: () => import('@/views/train/examinationManagement/examStatistic.vue'),
    meta: {
      title: '考试统计',
      titleKey: 'name',
      parentAuth: '/train/examinationManagement/list'
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    })
  },
  {
    name: 'projectManagementList',
    path: '/train/projectManagement/list',
    component: () => import('@/views/train/projectManagement/list.vue'),
    meta: {
      title: '培训项目管理'
    }
  },
  {
    name: 'trainingProjectStatistics',
    path: '/train/statistics',
    component: () => import('@/views/train/statistics/index.vue'),
    meta: {
      title: '培训项目统计',
      titleKey: 'name',
      replaceSameTab: true,
      parentAuth: '/train/projectManagement/list'
    },
    props: (route) => ({
      pageKey: route.query.pageKey
    })
  },
  {
    name: 'projectManagementForm',
    path: '/train/projectManagement/form',
    component: () => import('@/views/train/projectManagement/projectForm/index.vue'),
    meta: {
      title: (route) => {
        const mode = route.query.mode;
        let name = route.query.name || '';

        if (name) {
          name = `(${name.length > 5 ? name.substr(0, 5) + '...' : name})`
        }

        if (mode === 'add') {
          return '新增培训项目';
        } else if (mode === 'edit') {
          return '编辑培训项目' + name;
        } else if (mode === 'view') {
          return '查看培训项目' + name;
        } else if (mode === 'copy') {
          return '复制培训项目' + name;
        }
      },
      parentAuth: '/train/projectManagement/list'
    },
    props: (route) => ({
      ...route.query, // 接收 id ，mode
    })
  }
];
